import { ErrorPage, Link, LoadingPage, Select } from '@chocolate-soup-inc/cs-frontend-components';
import { useCallback } from 'react';
import { TOnDrop, Uploader } from '../../../components/uploader/Uploader';

import { toast } from 'react-toastify';
import { useQueryListAllCompaniesOptions } from '../../../entities/companies/queries';
import styles from './Import.module.scss';

type TFirstStepProps = {
  companyId?: string;
  file?: File;
  setCompanyId: React.Dispatch<React.SetStateAction<string | undefined>>;
  setFile: React.Dispatch<React.SetStateAction<File | undefined>>;
};

export const Step1 = (props: TFirstStepProps) => {
  const { companyId, file, setCompanyId, setFile } = props;

  const onDrop: TOnDrop = useCallback(
    (acceptedFiles) => {
      if (setFile) setFile(acceptedFiles[0]);
    },
    [setFile]
  );

  const { data: companies, error, loading } = useQueryListAllCompaniesOptions();

  if (loading) return <LoadingPage />;

  if (error) {
    console.error('query Apollo ERROR: ', error);
    toast.error('An error has ocurred, check the console for details. (query Apollo ERROR)');
    //if (error.message) toast.error(error.message);
    if (!companies) return <ErrorPage error={error} />;
  }

  return (
    <div className={styles.content}>
      <Select
        label='Company'
        multiple={false}
        name='companyId'
        onChange={(v) => {
          setCompanyId(v as string);
        }}
        options={companies?.map((c) => {
          return {
            label: c.name,
            value: c.id
          };
        })}
        value={companyId}
      />
      <p className={styles.supportText}>
        {'Upload an Excel file to import all the employees in the file to a company. The file must follow the format of '}
        <Link href='https://docs.google.com/spreadsheets/d/1zQmGOD3vhY7xSaBut8fBclrox0e1is668mt7cMCCNhw/edit?usp=sharing' label='this sheet' />. It must contain only one employee per row.
      </p>
      <small>Please consider: the Roster Import takes the data ONLY from the FIRST sheet of the file.</small>
      <Uploader file={file} onDrop={onDrop} />
    </div>
  );
};
